import { TemplateConfig } from '../../template-config.interface';
import { MACRO_BREADCRUMB_CONFIG } from './config/breadcrumb-config';
import { MACRO_CHANNEL_CONFIG } from './config/channel-config';

export const macroSacaTuTarjeta: TemplateConfig = {
  id: 'macro-saca-tu-tarjeta',
  clientId: 'MACRO',
  title: 'Sacá tu tarjeta',
  description: 'Template para campañas de tarjetas',
  aspectRatio: 'vertical',
  image: '',
  optimized_image:
    'https://media.backend.doer.ar/brands/assets/MACRO/templates/macro-saca-tu-tarjeta/thumbnails/optimized/macro-awareness-optimized.png',

  video: '',

  channelConfigs: MACRO_CHANNEL_CONFIG,

  breadcrumbConfig: MACRO_BREADCRUMB_CONFIG,

  formFields: [
    {
      key: 'title',
      label: 'Nombre del proyecto',
      type: 'input',
      placeholder: 'Nombre para identificar este asset',
      required: true
    },
    {
      key: 'stage',
      label: 'Etapa',
      type: 'select',
      required: true,
      options: [
        {
          value: 'AWARENESS',
          label: 'Awareness'
        },
        {
          value: 'CONSIDERACION',
          label: 'Consideración'
        },
        {
          value: 'CONVERSION',
          label: 'Conversión'
        }
      ],
      defaultValue: 'CONVERSION'
    },
    {
      key: 'variant',
      label: 'Motivo',
      type: 'select',
      required: true,
      options: [
        { value: '1', label: '1' },
        { value: '2', label: '2' },
        { value: '3', label: '3' },
        { value: '4', label: '4' },
        { value: '5', label: '5' }
      ],
      defaultValue: '1'
    },
    {
      key: 'adChannel',
      label: 'Medio',
      type: 'select',
      required: true,
      options: [
        {
          value: 'google',
          label: 'Google'
        },
        {
          value: 'meta',
          label: 'Meta'
        }
      ]
    },
    {
      key: 'claim',
      label: 'Titular (Máx. 3 líneas)',
      type: 'input',
      placeholder: `¿Vacaciones?
Pedí tu TARJETA
MACRO hoy.`,
      required: true,
      multiline: true
    },
    {
      key: 'highlighted_word_index',
      label: 'Palabra a resaltar',
      type: 'number',
      placeholder: `Número de palabra a resaltar (ej: 1, 2, 3...)`,
      required: true,
      min: 1,
      description: 'Índice de la palabra en el claim que se desea resaltar (comenzando desde 1)'
    },
    {
      key: 'subheadline_enabled',
      label: 'Incluir bajada',
      type: 'switch',
      required: false,
      defaultValue: 'no',
      valueType: 'string'
    },
    {
      key: 'subheadline',
      label: 'Bajada (Máx. 2 líneas)',
      type: 'input',
      placeholder: `Más límite para disfrutar tus compras`,
      required: false,
      multiline: true
    },
    {
      key: 'cta_enabled',
      label: 'Incluir CTA',
      type: 'switch',
      required: false,
      defaultValue: 'no',
      valueType: 'string'
    },
    {
      key: 'cta_text',
      label: 'Texto del CTA',
      type: 'input',
      placeholder: 'Sacá tu TARJETA',
      required: false,
      defaultValue: ''
    },
    {
      key: 'legal',
      label: 'Incluir legal',
      type: 'switch',
      required: false,
      defaultValue: 'no',
      valueType: 'string'
    }
  ],

  promptTemplate: '',
  hidePromptTemplate: true
};
